<template>
  <div>
    <h4 data-v-8e45b648 class="text-primary text-center text-sm-left mb-4 font-weight-bold">{{ $t('heading') }}</h4>
    <div v-if="savedShiurim.length > 0">
      <div class="row mb-4">
        <div class="col-md-6">
          <b-form-input id="input-3" v-model="filterQuery" :placeholder="$_t('KW:filterShiur')"></b-form-input>
        </div>
      </div>
      <paginate class="p-0" name="filteredSavedShiurim" :list="filteredSavedShiurim" :per="18">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 col-xl-2 mb-5 mb-md-4" v-if v-for="row in paginated('filteredSavedShiurim')">
            <div class="shiurim-card h-100">
              <shiurim-card :shiurim="row"></shiurim-card>
            </div>
          </div>
        </div>
      </paginate>
      <paginate-links
        v-if="paginated('filteredSavedShiurim').length < filteredSavedShiurim.length"
        :classes="{
          ul: 'pagination',
          li: 'page-item',
          a: 'page-link',
        }"
        for="filteredSavedShiurim"
      ></paginate-links>
    </div>
    <div v-else>
      <div class="alert alert-info">{{ $t('bookmarkCaption') }}</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ShiurimCardComponent from '../partials/ShiurimCard.vue';
import VuePaginate from 'vue-paginate';
Vue.use(VuePaginate);

export default {
  components: {
    ShiurimCard: ShiurimCardComponent,
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'savedShiurim',
  },
  data() {
    return {
      filterQuery: '',
      filteredSavedShiurim: [],
      paginate: ['filteredSavedShiurim'],
    };
  },
  watch: {
    savedShiurim: function (newVal) {
      this.filteredSavedShiurim = newVal;
    },
    filterQuery: function (newVal) {
      if (newVal.length > 0) {
        this.filteredSavedShiurim = this.savedShiurim.filter(shiur => shiur.name.toLowerCase().includes(newVal.toLowerCase()));
      } else {
        this.filteredSavedShiurim = this.savedShiurim;
      }
    },
  },
  computed: {
    savedShiurim: function () {
      let shiurim = this.$store.state.profile.savedShiurim;
      this.filteredSavedShiurim = shiurim;
      return shiurim;
    },
  },
};
</script>

<style>
</style>